export default [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    time: "113:27:25",
    activity: 50,
    idle: 11,
    notes: 5,
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=2",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Peak Quest",
    projectRole: "Research Lead",
    time: "95:18:12",
    activity: 44,
    idle: 10,
    notes: 4,
  }
];
